import Table from "react-bootstrap/Table";
import { Row, Col } from "react-bootstrap";
import FormTexts from "../../../constants/forms";
import Headings from "../../../constants/headings";
import Constants from "../../../constants/constants";
import { ModalContainer } from "../../../shared/index";
import { formsButtonType,ModalContentType } from "../../../enums/index";
import React, { useEffect, useCallback, useState, useRef } from "react";
import { ToPersianNumber, DateToPersianNumber } from "../../../functions/index";
import CustomerNidVerificationResult from "../../../enums/CustomerNidVerificationResult";
function AuthHistory(props) {
   const [rows, setRows] = useState([]);
  const [show, setShow] = useState(false);
  const request = useRef(null);
  const tableRows = useCallback(() => {
    let tempRows = [];
    props.customer.ActivityHistory.VerificationHistoryItems.forEach((v) => {      
      let reason = "";
      if (v.Reason)
        reason =
          Constants.AuthHistoryArray.reason +
          Constants.AuthHistoryArray.space +
          Constants.AuthHistoryArray.column +
          Constants.AuthHistoryArray.space +
          v.Reason;
      let tempText =
        Constants.AuthHistoryArray.check +
        Constants.AuthHistoryArray.space +
        Constants.AuthHistoryArray.column +
        Constants.AuthHistoryArray.space +
        Constants.AuthHistoryArray.nonsense ;
      if (v.Result === CustomerNidVerificationResult.Accepted())
        tempText =
          Constants.AuthHistoryArray.check +
          Constants.AuthHistoryArray.space +
          Constants.AuthHistoryArray.column +
          Constants.AuthHistoryArray.space +
          Constants.AuthHistoryArray.accept;
      if (v.Result === CustomerNidVerificationResult.Rejected())
        tempText =
          Constants.AuthHistoryArray.check +
          Constants.AuthHistoryArray.space +
          Constants.AuthHistoryArray.column +
          Constants.AuthHistoryArray.space +
          Constants.AuthHistoryArray.reject;
      let item = {
        Date: v.Date,
        Username: v.Username,
        Text: tempText,
        Reason:reason,
        Request: null,
      };
      tempRows.push(item);
      tempRows.sort(function (a, b) {
        return new Date(b.Date) - new Date(a.Date);
      });
      setRows(tempRows);
    });
    props.customer.ActivityHistory.InquiryHistoryItems.forEach((i) => {
      let reason = "";
      if (i.Reason)
        reason =
          Constants.AuthHistoryArray.reason +
          Constants.AuthHistoryArray.space +
          Constants.AuthHistoryArray.column +
          Constants.AuthHistoryArray.space +
          i.Reason;
      let results = JSON.parse(i.SerializedInquiryResult);
      let tempText =
        Constants.AuthHistoryArray.inquire +
        Constants.AuthHistoryArray.space +
        Constants.AuthHistoryArray.column +
        Constants.AuthHistoryArray.space +
        Constants.AuthHistoryArray.name +
        Constants.AuthHistoryArray.open +
        results.FirstName +
        Constants.AuthHistoryArray.close +
        ToPersianNumber(results.FirstNameSimilarity) +
        Constants.AuthHistoryArray.space +
        Constants.AuthHistoryArray.from +
        Constants.AuthHistoryArray.space +
        ToPersianNumber(Constants.AuthHistoryArray.hundred) +
        Constants.AuthHistoryArray.comma +
        Constants.AuthHistoryArray.space +
        Constants.AuthHistoryArray.family +
        Constants.AuthHistoryArray.open +
        results.LastName +
        Constants.AuthHistoryArray.close +
        Constants.AuthHistoryArray.space +
        ToPersianNumber(results.LastNameSimilarity) +
        Constants.AuthHistoryArray.space +
        Constants.AuthHistoryArray.from +
        Constants.AuthHistoryArray.space +
        ToPersianNumber(Constants.AuthHistoryArray.hundred) +
        Constants.AuthHistoryArray.comma +
        Constants.AuthHistoryArray.space +
        Constants.AuthHistoryArray.fathersName +
        Constants.AuthHistoryArray.open +
        results.FatherName +
        Constants.AuthHistoryArray.close +
        Constants.AuthHistoryArray.space +
        ToPersianNumber(results.FatherNameSimilarity) +
        Constants.AuthHistoryArray.space +
        Constants.AuthHistoryArray.from +
        Constants.AuthHistoryArray.space +
        ToPersianNumber(Constants.AuthHistoryArray.hundred) +
        Constants.AuthHistoryArray.comma +
        Constants.AuthHistoryArray.space +
        Constants.AuthHistoryArray.with +
        Constants.AuthHistoryArray.space +
        Constants.AuthHistoryArray.nationalCode +
        Constants.AuthHistoryArray.open +
        ToPersianNumber(results.NationalCode) +
        Constants.AuthHistoryArray.close +
        Constants.AuthHistoryArray.space +
        Constants.AuthHistoryArray.and +
        Constants.AuthHistoryArray.space +
        Constants.AuthHistoryArray.birthDate +
        Constants.AuthHistoryArray.open +
        DateToPersianNumber(results.BirthDate) +
        Constants.AuthHistoryArray.close;
      if (results.Message) {
        tempText = Constants.AuthHistoryArray.error;
      }
      let item = {
        Date: i.Date,
        Username: i.Username,
        Text: tempText,
        Reason:reason,
        Request: JSON.parse(i.SerializedInquiryRequest),
      };
      tempRows.push(item);
      tempRows.sort(function (a, b) {
        return new Date(b.Date) - new Date(a.Date);
      });
      setRows(tempRows);
    });
  }, [
    props.customer.ActivityHistory.VerificationHistoryItems,
    props.customer.ActivityHistory.InquiryHistoryItems,
  ]);
  const openDetails = (e, data) => {
    e.preventDefault();
    request.current = data;
    setShow(true);
  };
  const handleClose = (e = null) => {
    if (e) e.preventDefault();
    setShow(false);
  };
  useEffect(() => {
    tableRows();
  }, [tableRows]);
  return (
    rows &&
    props.customer && (
      <>
        <h2>{Headings.AuthTableTitle} </h2>
        <Row>
          <Col>
            {props.customer && (
              <Table responsive className="roundedCorners">
                <thead>
                  <tr>
                    {Headings.AuthHistoryTableHeading.map((h, index) => (
                      <th key={index}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {rows.map((v, index) => (
                    <tr key={index}>
                      <td>{DateToPersianNumber(v.Date.replace("T", " "))}</td>
                      <td>{v.Username}</td>
                      <td>{v.Text}<br></br>{v.Reason}</td>
                      {v.Request ? (
                        <td className="text-center">
                          <span
                            className="cursor-pointer color-blue"
                            onClick={(e) => openDetails(e, v.Request)}
                            variant="success"
                          >
                            {FormTexts.Buttons(formsButtonType.Show())}
                          </span>
                        </td>
                      ) : (
                        <td></td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </Col>
        </Row>
        <ModalContainer
          show={show}
          type={ModalContentType.AuthHistory()}
          title={Headings.InquiryRequestTitle}
          handleClose={handleClose}
          data={request.current}
        ></ModalContainer>
      </>
    )
  );
}
export default AuthHistory;
